var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fotWrap" }, [
    _vm.showQus
      ? _c("div", { staticClass: "fotTxt" }, [
          _c("h1", [_vm._v("Haven't found what you're looking for?")]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              "\n      Interested in our house & land packages? Enquire to find out more!\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: _vm.link, target: "_Blank" }
            },
            [_vm._v("Submit a request")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "fotCon" }, [
      _c("div", { staticClass: "top clear" }, [
        _c("div", {
          staticClass: "logo",
          class: "logoOnWhite-" + _vm.tenant,
          on: { click: _vm.toMain }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "share clear" }, [
          _vm.socialTwitter != null
            ? _c("a", {
                staticClass: "twitter",
                attrs: { href: _vm.socialTwitter, target: "_blank" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.socialFacebook != null
            ? _c("a", {
                staticClass: "twitter1",
                attrs: { href: _vm.socialFacebook, target: "_blank" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.socialInstagram != null
            ? _c("a", {
                staticClass: "facebook",
                attrs: { href: _vm.socialInstagram, target: "_blank" }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c(
          "ul",
          { staticClass: "clear" },
          [
            _c("li", { staticClass: "my_newLi" }, [
              _c(
                "a",
                { attrs: { href: _vm.urlObj.evtutl, target: "_blank" } },
                [_vm._v("Events")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "my_newLi" }, [
              _c(
                "a",
                { attrs: { href: _vm.urlObj.eduurl, target: "_blank" } },
                [_vm._v("Education")]
              )
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "my_newLi", attrs: { tag: "li", to: "/faq" } },
              [_vm._v("FAQ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "my_newLi", attrs: { tag: "li", to: "/account" } },
              [_vm._v("Account")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "my_newLi", attrs: { tag: "li", to: "/abous" } },
              [_vm._v("About us")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "my_newLi",
                attrs: { tag: "li", to: "/affiliate" }
              },
              [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.refresh("/affiliate")
                      }
                    }
                  },
                  [_vm._v("Affiliated companies")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "my_newLi", attrs: { tag: "li", to: "/contact" } },
              [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.refresh("/contact")
                      }
                    }
                  },
                  [_vm._v("Contact us")]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticStyle: { "padding-bottom": ".2rem" } },
          [
            _c("router-link", { attrs: { tag: "strong", to: "/term" } }, [
              _c(
                "i",
                {
                  on: {
                    click: function($event) {
                      return _vm.refresh("/term")
                    }
                  }
                },
                [_vm._v("Terms & Conditions")]
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("|")]),
            _vm._v(" "),
            _c("router-link", { attrs: { tag: "strong", to: "/policy" } }, [
              _c(
                "i",
                {
                  on: {
                    click: function($event) {
                      return _vm.refresh("/policy")
                    }
                  }
                },
                [_vm._v("Privacy Policy")]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-decoration": "none" } }, [
          _vm._v("\n        team@unifiproperty.com COPYRIGHT 2020\n      ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1eed0d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1eed0d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/footer.vue
// module id = null
// module chunks = 